import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  const cloned = req.clone({ withCredentials: true });

  // Password-recovery endpoints own their own invalid/expired-key UI — a 401/403
  // here must not force-redirect to /auth and clobber that page's error state.
  const isPasswordRecovery =
    req.url.includes('accounts/forgot-password/') ||
    req.url.includes('accounts/check-reset-password-key/') ||
    req.url.includes('accounts/reset-password/');

  return next(cloned).pipe(
    catchError((error) => {
      if (isPasswordRecovery) {
        return throwError(() => error);
      }

      const isAuthCheck = req.url === `${environment.api}accounts/session/`;

      if (!isAuthCheck && (error.status === 401 || error.status === 403)) {
        const isAuthRoute = router.url.startsWith('/auth');

        if (!isAuthRoute) {
          router.navigate(['/auth']);
        }
      }

      return throwError(() => error);
    }),
  );
};
